/**
 * @fileoverview Recoveries Phase shell.
 *
 * Purpose: Phase 6 — Pursuing Recoveries. Renders the section outlet:
 * the overview at the index, section workspaces under `$section`.
 * URL: /dashboard/jobs/:jobId/recoveries
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries",
)({
  component: RecoveriesPhase,
});

function RecoveriesPhase() {
  return <Outlet />;
}
